import { Textarea, TextareaProps } from "@fluentui/react-components";
import { DragEvent, DragEventHandler, memo, useCallback, useEffect } from "react";
import parseHtmlContent from "../../../utils/parseHtmlContent";
import { onInputHandleResize, useDropboxTextAreaStyles } from "../styles/DropboxTextArea.styles";

type DropboxTextAreaProps = {
  onChange: (value: string) => void;
  value: string;
} & Omit<TextareaProps, "value" | "onChange">;

export const DropboxTextArea = memo(({ value, onChange, ...props }: DropboxTextAreaProps) => {
  const styles = useDropboxTextAreaStyles();

  const onDragOver: DragEventHandler<HTMLDivElement> = (ev) => {
    ev.preventDefault();
  };

  const onDrop: DragEventHandler<HTMLDivElement> = (ev: DragEvent<HTMLDivElement>) => {
    const htmlContent = ev.dataTransfer.getData("text/html") || `<p>${ev.dataTransfer.getData("text/plain")}</p>`;
    const text = parseHtmlContent(htmlContent);
    if (text) {
      onChange(value + text);
    }
  };

  useEffect(() => {
    const textArea: any = document.querySelector("textarea");
    if (textArea) {
      onInputHandleResize({ currentTarget: textArea } as any);
    }
  }, [value]);

  const handleChange = useCallback(
    (_ev: any, data: any) => {
      onChange(data.value as string);
    },
    [onChange]
  );

  return (
    <div className={styles.inputContainer} onDragOver={onDragOver} onDrop={onDrop}>
      <Textarea
        {...props}
        className={styles.input}
        onChange={handleChange}
        onInput={onInputHandleResize}
        placeholder="Describe what you want to find in natural language or paste in a provision from your document."
        textarea={{ style: { maxHeight: "148px" } }}
        value={value}
      />
    </div>
  );
});
